import { DumpLoadStatus } from '@common/enums';
import React, { FC, useMemo } from 'react';

import { COLORS, makeStyles } from '~/@components/@theme';
import { FormikSelectField } from '~/@components/FormikFields';
import { LocalizableText } from '~/@components/LocalizableText';
import { InboundIcon, Output } from '~/@sochi-components/Icons';

import { DeliveryLineDumpLoad, useDeliveryLineFormikContext } from './DeliveryLineFormikCommon';

const DumpLoadInfo: FC<{ dumpLoad: DeliveryLineDumpLoad }> = ({ dumpLoad }) => {
    const { root, icon } = useStyle();

    return (
        <div className={root}>
            {dumpLoad.serialNumber}
            {dumpLoad.inbound ? <InboundIcon className={icon} /> : <Output className={icon} />}
        </div>
    );
};

export const DeliveryLineEditOrderSelect: FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    const formik = useDeliveryLineFormikContext();

    // Allow change only to the IN_PROGRESS dump load
    const items: DeliveryLineDumpLoad[] = useMemo(
        () =>
            formik.values.project.dumpLoads.filter(
                d =>
                    d.status === DumpLoadStatus.IN_PROGRESS ||
                    d.serialNumber === formik.values.deliveryLine?.serialNumber
            ),
        [formik]
    );

    return (
        <FormikSelectField
            label={<LocalizableText code={'DeliveryLineCard.orderNumber'} />}
            name={'dumpLoad'}
            formik={formik}
            items={items}
            renderValue={(dumpLoad: DeliveryLineDumpLoad) => <DumpLoadInfo dumpLoad={dumpLoad} />}
            keyGetter={(dumpLoad: DeliveryLineDumpLoad) => dumpLoad.serialNumber}
            disabled={disabled}
            addEmptyOption={false}
        />
    );
};

const useStyle = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        gap: '4px',
    },
    icon: {
        color: COLORS.grayDark,
    },
}));
